import { useRef, useState } from "react";
import { Camera, X } from "lucide-react";
import { compressImage } from "@/lib/util";
import { tr as t } from "@/lib/i18n";

export default function PhotoPicker({ files, onChange, testid = "photo-picker" }) {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const add = async (e) => {
    const picked = Array.from(e.target.files || []);
    e.target.value = "";
    setBusy(true);
    const out = [];
    for (const f of picked) out.push(await compressImage(f));
    setBusy(false);
    onChange([...files, ...out].slice(0, 10));
  };
  return (
    <div>
      <input ref={ref} type="file" accept="image/*" multiple hidden onChange={add} data-testid={`${testid}-input`} />
      <div className="grid grid-cols-3 gap-2">
        {files.map((f, i) => (
          <div key={i} className="relative aspect-square rounded-xl overflow-hidden border">
            <img src={URL.createObjectURL(f)} alt="" className="w-full h-full object-cover" />
            <button type="button" onClick={() => onChange(files.filter((_, j) => j !== i))}
              className="absolute top-1 left-1 w-8 h-8 rounded-full bg-black/60 text-white flex items-center justify-center"><X className="w-5 h-5" /></button>
          </div>
        ))}
        <button type="button" data-testid={`${testid}-add`} onClick={() => ref.current.click()} disabled={busy}
          className="aspect-square rounded-xl border-2 border-dashed border-blue-300 bg-blue-50 text-blue-700 flex flex-col items-center justify-center gap-1 font-bold">
          <Camera className="w-9 h-9" />{busy ? t("جاري التجهيز") : t("صورة")}
        </button>
      </div>
    </div>
  );
}
